<tt-page>
    <tt-grid *ngIf="!!gridAcVatCode" class="flex-1" [(ttOptions)]="gridAcVatCode"></tt-grid>
    <tt-grid *ngIf="!!gridData" class="flex-1" [(ttOptions)]="gridData"></tt-grid>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <tt-grid ng-if="vm.model.gridAcVatCodeReady" class="col-xs-12 sp-0 flex-1" tt-options="vm.gridAcVatCode"></tt-grid>
    <tt-grid ng-if="vm.model.gridDataReady" class="col-xs-12 sp-0 flex-1" tt-options="vm.gridData"></tt-grid>
</tt-page>-->
